/** @format */

import {
	CUSTOM_ELEMENTS_SCHEMA,
	ChangeDetectionStrategy,
	Component,
	OnInit,
	input
} from '@angular/core';
import { Chain, Environment, ProcessedProduct } from '@shared/data-access/interfaces';

import { UtilityService } from '@shared/data-access/services';

@Component({
	selector: 'pdp-component-syndigo',
	templateUrl: './syndigo.component.html',
	styleUrl: './syndigo.component.scss',
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class SyndigoComponent implements OnInit {
	/**
	 * @description
	 * Syndigo Feature Flag
	 */
	readonly syndigoEnabled = input<boolean>(false);

	/**
	 * @description
	 * The current product
	 */
	readonly product = input<ProcessedProduct>();

	constructor(
		public chain: Chain,
		public environment: Environment,
		private utilityService: UtilityService
	) {}

	ngOnInit(): void {
		// Feature Flag is being pulled from the in-stock-default component
		if (this.syndigoEnabled()) {
			// Load Script
			this.enableSyndigo();
		}
	}

	/**
	 * Loads script Syndigo provided
	 */
	private enableSyndigo() {
		// Node upgrade removing nested template literals
		// this.utilityService.loadExternalScript(
		// 	`assets/plugins/syndigo/syndigo${this.chain.chainIdentifierAbbr === 'dsg' ? '' :
		// 	 `_${this.chain.chainIdentifierAbbr}`}.js`
		// );

		const chainIdentifierAbbr = this.chain.chainIdentifierAbbr;
		const scriptPath =
			chainIdentifierAbbr === 'dsg'
				? 'assets/plugins/syndigo/syndigo.js'
				: `assets/plugins/syndigo/syndigo_${chainIdentifierAbbr}.js`;

		const fnLoadSyndigo = () => this.utilityService.loadExternalScript(scriptPath);
		this.utilityService.runWhenIdle(fnLoadSyndigo);
	}
}
